import { nfmt } from '../lib/format';

/**
 * Три валюты — три разные формы, а не три цвета одной иконки.
 * Требование ТЗ: их нельзя перепутать даже боковым зрением.
 */

export function CoinIcon({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden>
      <circle cx="12" cy="12" r="10" fill="var(--gold)" />
      <circle cx="12" cy="12" r="6.5" fill="none" stroke="#0A0C18" strokeOpacity=".45" strokeWidth="1.6" />
      <path d="M12 8.5v7M9.6 10.4h4.8M9.6 13.6h4.8" stroke="#0A0C18" strokeOpacity=".65" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

export function CrystalIcon({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden>
      <path d="M12 2 21 9.5 12 22 3 9.5z" fill="var(--violet)" />
      <path d="M12 2 8 9.5 12 22 16 9.5z" fill="#fff" fillOpacity=".22" />
      <path d="M3 9.5h18" stroke="#0A0C18" strokeOpacity=".35" strokeWidth="1.2" />
    </svg>
  );
}

export function TicketIcon({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden>
      <path
        d="M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2.2a2.8 2.8 0 0 0 0 5.6V17a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2.2a2.8 2.8 0 0 0 0-5.6z"
        fill="var(--turq)"
      />
      <path d="M14.5 6.5v11" stroke="#0A0C18" strokeOpacity=".5" strokeWidth="1.4" strokeDasharray="2 2.4" />
    </svg>
  );
}

export function Amount({ kind, value, size = 15 }: {
  kind: 'coin' | 'crystal' | 'spin'; value: number; size?: number;
}) {
  const Icon = kind === 'coin' ? CoinIcon : kind === 'crystal' ? CrystalIcon : TicketIcon;
  const color = kind === 'coin' ? 'text-gold' : kind === 'crystal' ? 'text-violet' : 'text-turq';
  return (
    <span className={`inline-flex items-center gap-1 font-semibold num ${color}`}>
      <Icon size={size} />
      {value > 0 ? '+' : ''}{nfmt(value)}
    </span>
  );
}
